// src/component/datatable2/models/TextFilterOptions.ts

export interface FilterOption {
    id: string;
    label: string;
}

/** Checkbox options of the text filter panel: distinct values of the loaded rows. */
export class TextFilterOptions {
    /** Value at a dotted path ("device.name"); undefined when a step is missing. */
    static valueAt(row: unknown, fieldName: string): unknown {
        if (!row || !fieldName) {
            return undefined;
        }

        return fieldName.split('.').reduce<unknown>((current, key) => {
            if (current === null || current === undefined) {
                return undefined;
            }

            return (current as Record<string, unknown>)[key];
        }, row);
    }

    /** Distinct, non-empty values of a field, in first-seen order. */
    static fromRows(rows: readonly unknown[], fieldName: string): FilterOption[] {
        const values = rows
            .map(row => TextFilterOptions.valueAt(row, fieldName))
            .filter(value => value !== null && value !== undefined && value !== '')
            .map(value => String(value));

        return Array.from(new Set(values)).map(value => ({ id: value, label: value }));
    }
}
